interface ContentBlock {
  type: "paragraph" | "heading";
  text: string;
}

interface ArticleContentProps {
  content: ContentBlock[];
  tags: string[];
}

export default function ArticleContent({ content, tags }: ArticleContentProps) {
  return (
    <article className="max-w-[780px] mx-auto px-6 md:px-10 py-10 md:py-14">
      {/* Article body */}
      <div className="prose-custom">
        {content.map((block, index) => {
          if (block.type === "heading") {
            return (
              <h2
                key={index}
                className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-10 mb-4 first:mt-0"
              >
                {block.text}
              </h2>
            );
          }
          return (
            <p
              key={index}
              className="text-base leading-relaxed text-foreground-700 mb-5"
            >
              {block.text}
            </p>
          );
        })}
      </div>

      {/* Tags */}
      {tags && tags.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 mt-12 pt-8 border-t border-background-200/70">
          <span className="text-sm font-medium text-foreground-500 mr-1">
            <i className="ri-price-tag-3-line mr-1"></i>
            标签：
          </span>
          {tags.map((tag) => (
            <span
              key={tag}
              className="px-3 py-1.5 bg-background-100 border border-background-200/70 rounded-full text-xs font-medium text-foreground-600 hover:text-primary-600 hover:border-primary-200 hover:bg-primary-50/50 transition-colors duration-200 cursor-pointer"
            >
              #{tag}
            </span>
          ))}
        </div>
      )}

      {/* Share bar */}
      <div className="flex items-center gap-3 mt-8 pt-6 border-t border-background-200/70">
        <span className="text-sm font-medium text-foreground-500">分享到：</span>
        <button
          type="button"
          className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/70 text-foreground-600 hover:text-accent-500 hover:border-accent-300 transition-all duration-200 cursor-pointer"
          aria-label="分享到微博"
        >
          <i className="ri-weibo-line text-base"></i>
        </button>
        <button
          type="button"
          className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/70 text-foreground-600 hover:text-secondary-500 hover:border-secondary-300 transition-all duration-200 cursor-pointer"
          aria-label="分享到微信"
        >
          <i className="ri-wechat-line text-base"></i>
        </button>
        <button
          type="button"
          className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/70 text-foreground-600 hover:text-foreground-900 hover:border-foreground-300 transition-all duration-200 cursor-pointer"
          aria-label="复制链接"
        >
          <i className="ri-links-line text-base"></i>
        </button>
        <button
          type="button"
          className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 border border-background-200/70 text-foreground-600 hover:text-primary-500 hover:border-primary-300 transition-all duration-200 cursor-pointer"
          aria-label="收藏文章"
        >
          <i className="ri-bookmark-line text-base"></i>
        </button>
      </div>
    </article>
  );
}